import axiosClient from '@/api/axiosClient';
import { API_GET_MISSION, API_REPORT_MISSION, API_UPDATE_MISSION } from '@/config/paths/API_PATH';

async function getMissions({ name, isActive }) {
  const { data } = await axiosClient.get(API_GET_MISSION, {
    params: {
      name,
      is_active: isActive,
    },
  });
  return data;
}

// async function updateMission({
//   id,
//   nameEn,
//   nameMy,
//   cycle,
//   heart,
//   numberMission,
//   action,
//   isActive,
// }) {
//   const { data } = await axiosClient.post(API_UPDATE_MISSION, {
//     id,
//     name_en: nameEn,
//     name_my: nameMy,
//     cycle,
//     heart,
//     number_mission: numberMission,
//     action,
//     is_active: isActive,
//   });
//   return data;
// }

async function updateMission(payload) {
  const { data } = await axiosClient.post(API_UPDATE_MISSION, {
    ...payload,
  });

  return data;
}

async function getMissionReport(payload) {
  const { data } = await axiosClient.get(API_REPORT_MISSION, {
    params: payload,
  });

  return data;
}

export { getMissions, updateMission, getMissionReport };
